<script type="ts" context="module">
	import { dev } from '$app/env';
	import type { Load } from '@sveltejs/kit';

	async function fetchHydration<T>(
		fetch: T,
		url: string
	): Promise<BeautifiedCode.MinifiedTokens | undefined> {
		const response = await fetch(url);
		const text = await response.text();
		try {
			const json = JSON.parse(text);
			return json;
		} catch (e) {
			if (dev) {
				console.log('Tried to hydrate ' + url);
				console.log('Could not parse code as JSON', text);
			}
		}
	}

	async function getJSON(request: Promise<Response>): Promise<string | object> {
		const response = await request;

		if (response.status !== 200) {
			console.error(`Could not fetch ${response.url}`);
			return {};
		}

		const text = await response.text();
		try {
			return JSON.parse(text);
		} catch (e) {
			console.error('Could not parse code as JSON', text);
			return text;
		}
	}

	export const load: Load = async ({ fetch, url }) => {
		const slug = url.pathname.slice(1).split('/').pop();

		if (!slug) {
			throw new Error(`No slug found in ${url.pathname}`);
		}

		const fetch_preload = fetch(`/api/${encodeURIComponent(slug)}/preload.json`, {
			method: 'GET'
		});
		const fetch_hydrate = fetch(`/api/${encodeURIComponent(slug)}/hydrate.json`, {
			method: 'GET'
		});

		const preload = await getJSON(fetch_preload);
		const hydrate = await getJSON(fetch_hydrate);

		const results = {
			status: 200,
			props: {
				examples: preload
			},
			stuff: {
				hydratedExamples: hydrate
			}
		};

		return results;
	};
</script>

<script type="ts">
	import type { BeautifiedCode } from 'src/app';
	import { setContext } from 'svelte';

	export let examples: BeautifiedCode.Example[];

	setContext('examples', examples);
</script>

<slot />
